import React, { useState } from 'react';
import { Form, Row, Col, Button, Badge, Collapse } from 'react-bootstrap';
import { FaChartBar, FaFilter } from 'react-icons/fa';
import './Filter.css';

const Filter = ({ filter, darkMode, count }) => {
  const [showFilters, setShowFilters] = useState(false);
  
  const {
    years,
    availableMonths,
    selectedYear,
    countries,
    selectedCountry,
    onYearChange,
    onCountryChange,
    states,
    grains,
    selectedState,
    selectedMonth,
    selectedGrain,
    onStateChange,
    onMonthChange,
    onGrainChange,
    onClearFilters
  } = filter;

  return (
    <div className={`map-filter-measure-wrapper ${darkMode ? 'dark' : 'light'}`}>
      <div className="map-filter-container">
        <div className="d-flex justify-content-between align-items-center">
          <div className="d-flex align-items-center">
            <FaChartBar className="me-2" />
            <h5 className="m-0 me-2">Mapa de Medições</h5>
          </div>
          <div className="d-flex align-items-center gap-2">
            <Badge bg={darkMode ? "light" : "secondary"} text={darkMode ? "dark" : "light"} className="map-count-badge">
              {count} medições
            </Badge>
            <Button
              variant={darkMode ? "outline-light" : "outline-secondary"}
              size="sm"
              onClick={() => setShowFilters(!showFilters)}
              className="d-flex align-items-center"
            >
              <FaFilter className="me-1" />
              Filtros
            </Button>
          </div>
        </div>
        
        <Collapse in={showFilters}>
          <div className="mt-3">
            <Form>
              <Row className="g-2">
                <Col xs={6}>
                  <Form.Group>
                    <Form.Label style={{ color: darkMode ? '#fff' : '#000', fontSize: '0.85rem' }}>Ano</Form.Label>
                    <Form.Select
                      size="sm"
                      value={selectedYear || ''}
                      onChange={(e) => onYearChange(e.target.value ? Number(e.target.value) : null)}
                    >
                      <option value="">Todos</option>
                      {years.map(year => (
                        <option key={year} value={year}>{year}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={6}>
                  <Form.Group>
                    <Form.Label style={{ color: darkMode ? '#fff' : '#000', fontSize: '0.85rem' }}>Mês</Form.Label>
                    <Form.Select
                      size="sm"
                      disabled={!selectedYear}
                      value={selectedMonth || ''}
                      onChange={(e) => onMonthChange(e.target.value ? Number(e.target.value) : '')}
                    >
                      <option value="">Todos</option>
                      {availableMonths.map(month => (
                        <option key={month} value={month}>
                          {new Date(0, month - 1).toLocaleString('pt-BR', { month: 'long' })}
                        </option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={6}>
                  <Form.Group>
                    <Form.Label style={{ color: darkMode ? '#fff' : '#000', fontSize: '0.85rem' }}>País</Form.Label>
                    <Form.Select
                      size="sm"
                      value={selectedCountry || ''}
                      onChange={(e) => onCountryChange(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {countries.map(country => (
                        <option key={country} value={country}>{country}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={6}>
                  <Form.Group>
                    <Form.Label style={{ color: darkMode ? '#fff' : '#000', fontSize: '0.85rem' }}>Estado</Form.Label>
                    <Form.Select
                      size="sm"
                      value={selectedState || ''}
                      onChange={(e) => onStateChange(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {states.map(state => (
                        <option key={state} value={state}>{state}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>

                <Col xs={6}>
                  <Form.Group>
                    <Form.Label style={{ color: darkMode ? '#fff' : '#000', fontSize: '0.85rem' }}>Grão</Form.Label>
                    <Form.Select
                      size="sm"
                      value={selectedGrain || ''}
                      onChange={(e) => onGrainChange(e.target.value)}
                    >
                      <option value="">Todos</option>
                      {grains.map(grain => (
                        <option key={grain} value={grain}>{grain}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </Col>
              </Row>
              
              <div className="d-flex justify-content-end mt-2">
                <Button
                  variant={darkMode ? "outline-light" : "outline-secondary"}
                  size="sm"
                  onClick={onClearFilters}
                >
                  <i className="bi bi-arrow-counterclockwise me-1"></i>
                  Limpar
                </Button>
              </div>
            </Form>
          </div>
        </Collapse>
      </div>
    </div>
  );
};

export default Filter;
